import * as React from "react"

export function Section({ children }) {
  return <div>{children}</div>
}

Section.defaultProps = {}
